export default class Baslide {
  constructor(target, options) {
    this.$target = target
    this.$track = this.$target.querySelector(".baslide__track")
    this.$dots = this.$target.querySelector(".baslide__dots")
    this.$arrows = this.$target.querySelector(".baslide__arrows")

    this.options = {
      perMove: 1,
      perPage: 1,
      responsive: {},
      ...options,
    }

    this.options.responsive = {
      ...this.options.responsive,
      base: {
        perMove: this.options.perMove,
        perPage: this.options.perPage,
      },
    }

    this.state = {
      activeIndex: 0,
      offsetWidth: this.$track.offsetWidth,
      scrollWidth: this.$track.scrollWidth,
      totalSlide: Math.floor(this.$track.scrollWidth / this.$track.offsetWidth),
    }

    this.connect()
  }

  connect = () => {
    this.disconnect()
    this.onReset()
    this.$track.addEventListener("scroll", this.onScroll)
  }

  disconnect() {
    this.$track.removeEventListener("scroll", this.onScroll)
  }

  onScroll = (e) => {
    const newIndex = Math.floor((e.target.scrollLeft + 5) / this.state.offsetWidth)

    this.state.activeIndex = newIndex
    this.renderDots()
    this.renderArrows()
  }

  onReset = (e) => {
    this.state = {
      activeIndex: 0,
      offsetWidth: this.$track.offsetWidth,
      scrollWidth: this.$track.scrollWidth,
      totalSlide: Math.floor(this.$track.scrollWidth / this.$track.offsetWidth),
    }

    for (let [breakpoint, options] of Object.entries(this.options.responsive)) {
      if (breakpoint > window.innerWidth) {
        this.options = {
          ...this.options,
          ...options,
        }
        break
      } else {
        this.options = {
          ...this.options,
          ...options,
        }
      }
    }

    this.$track.scrollTo(0, 0)
    this.renderArrows()
    this.renderDots()
  }

  handleArrowClick = (dir) => {
    let { perPage, perMove } = this.options
    perPage = this.state.offsetWidth / perPage
    perPage = perPage * perMove

    let x = this.$track.scrollLeft + perPage
    if (dir === "prev") {
      x = this.$track.scrollLeft - perPage
    }

    this.$track.scrollTo({
      left: x,
      top: 0,
      behavior: "smooth",
    })
  }

  renderDots = () => {
    if (this.$dots) {
      this.$dots.innerHTML = ""
      for (let i = 0; i <= this.state.totalSlide - 1; i++) {
        const dot = document.createElement("button")
        dot.classList.add("baslide__dot")

        if (i === this.state.activeIndex) dot.classList.add("baslide__dot--active")

        this.$dots.append(dot)
      }
    }
  }

  renderArrows = () => {
    if (!this.$arrows) return
    this.$arrows.innerHTML = ""
    const arr = ["prev", "next"]

    arr.forEach((dir) => {
      const $arrow = document.createElement("button")
      $arrow.classList.add("baslide__arrow")
      $arrow.classList.add(`baslide__arrow--${dir}`)
      $arrow.setAttribute('aria-label', dir)
      $arrow.innerHTML = `<span class="arrow"></span>`
      $arrow.onclick = () => this.handleArrowClick(dir)

      if (this.$track.scrollLeft <= 30 && dir == "prev") {
        $arrow.setAttribute("disabled", "true")
      }

      if (this.$track.scrollLeft >= this.$track.scrollWidth - this.$track.offsetWidth - 20 && dir == "next") {
        $arrow.setAttribute("disabled", "true")
      }

      this.$arrows.append($arrow)
    })
  }
}
